import { View as ReactNativeView, ViewProps } from "react-native";

export const View = (props: ViewProps) => <ReactNativeView {...props} />;
